//Start react page 
import React, { useState } from 'react';
import FormSelector from '../components/E2E/FormSelector';

function E2EUserPage() {
    return (
        <div>
            <main>
                <FormSelector />
            </main>
        </div>
  );
}

export default E2EUserPage;